import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="legal-page">
      <h1 className="legal-title">Privacy Policy</h1>
      
      <div className="legal-content">
        <section className="legal-section">
          <p>
            "Panda Notify" ("we", "us", or "our") operates the "pandanotify.com" website (pandanotify.com) (the "Service"). This privacy policy explains how we collect, use, protect, and disclose information from users of our website.
          </p>
        </section>
        <section className="legal-section">
          <h2>Information Collection</h2>
          <p>
            We collect a variety of information from and about our users in order to provide, improve, and personalize our services. The types of information we collect include but are not limited to:
          </p>
          <ul>
            <li>First and Last Name</li>
            <li>Phone Number</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Methods of Collection</h2>
          <p>We collect information in several ways:</p>
          <ul>
            <li><strong>Directly from You:</strong> When you register on our site, place an order, subscribe to our newsletter, fill out a form, subscribe to newsletters, make purchases, or contact customer support.</li>
            <li><strong>Automatically:</strong> As you navigate through our site, we automatically collect information about your equipment, browsing actions, and patterns, such as IP addresses, cookies, and usage details.</li>
            <li><strong>Public Sources:</strong> We may collect information about you from publicly accessible sources, such as social media profiles, government databases, and other online platforms. This information is used to verify the accuracy of data we already have, enhance user profiles, or provide more personalized services.</li>
            <li><strong>Communication and Feedback:</strong> We may collect information when you participate in surveys, provide feedback, or engage with us through social media platforms, email, or other communication channels.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Use of Information</h2>
          <p>We use the information collected for various purposes, including:</p>
          <ul>
            <li>Communicate with Users: Send users marketing, promotional materials, and updates about our services.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Information Sharing and Disclosure</h2>
          <p>
            Panda Notify maintains strict privacy policies to protect the personal information of our users. Text messaging opt-in data and consent will not be sold or shared with third parties or affiliates for their marketing or promotional purposes.
          </p>
          <p>We may share your personal information in the following situations:</p>
          <ul>
            <li><strong>Service Providers:</strong> With third-party vendors or service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, bankruptcy, or other transaction involving the sale or transfer of all or part of our assets, your personal information may be transferred as part of that transaction.</li>
            <li><strong>Legal Requirements:</strong> When required by law, such as to comply with a subpoena, court order, or other legal process.</li>
            <li><strong>Protecting Rights and Safety:</strong> When necessary to protect the rights, property, or safety of our company, our users, or others.</li>
            <li><strong>Affiliates:</strong> With our affiliates for internal business purposes.</li>
            <li><strong>Analytics and Advertising:</strong> With third-party analytics providers and advertising networks to deliver personalized ads and understand how users interact with our services.</li>
            <li><strong>Public Forums:</strong> Information shared in public forums may be visible to others.</li>
            <li><strong>Aggregate or Anonymized Information:</strong> We may share aggregate or anonymized information that cannot reasonably be used to identify you.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Information Protection</h2>
          <p>
            We are committed to ensuring the security of the personal information we collect. Our organization implements a variety of technical, administrative, and physical measures designed to protect your data from unauthorized access, disclosure, alteration, or destruction. These measures include but are not limited to:
          </p>
          <ul>
            <li><strong>Encryption:</strong> We use industry-standard encryption protocols to protect sensitive data during transmission and in storage.</li>
            <li><strong>Access Controls:</strong> We restrict access to personal information to authorized personnel only, based on their role and need to know. This includes the use of authentication measures such as passwords, multi-factor authentication, and role-based access controls.</li>
            <li><strong>Monitoring and Auditing:</strong> Our systems are continuously monitored for potential vulnerabilities and threats. We conduct regular audits and assessments to ensure our security practices meet current standards and to identify areas for improvement.</li>
            <li><strong>Data Minimization:</strong> We limit the collection and retention of personal data to what is necessary for the purposes outlined in this policy. Data that is no longer needed is securely deleted or anonymized.</li>
            <li><strong>Third-Party Security:</strong> When we work with third-party service providers who process data on our behalf, we ensure that they have appropriate security measures in place to protect your information.</li>
          </ul>
          <p>
            While we strive to protect your personal information, no method of transmission over the internet or electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security. However, we continually update and improve our security practices to protect your data.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Rights</h2>
          <p>You have the following rights regarding your personal information:</p>
          <ul>
            <li><strong>Access:</strong> You can request a copy of the personal data we hold about you.</li>
            <li><strong>Correction:</strong> You can request that we correct any inaccurate or incomplete data.</li>
            <li><strong>Deletion:</strong> You can request that we delete your personal data.</li>
          </ul>
          <p>To exercise these rights, please contact us using the contact information provided below.</p>
        </section>

        <section className="legal-section">
          <h2>Opt-Out</h2>
          <p>Users can opt-out of receiving future communications from us by:</p>
          <ul>
            <li>Following the unsubscribe instructions included in each email</li>
            <li>Replying "Stop" to any text message to discontinue text message communications</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your experience on our website, improve our services, and better understand how you interact with our content.
          </p>
          
          <h3>What Are Cookies?</h3>
          <p>
            Cookies are small text files that are placed on your device when you visit a website. They allow the website to recognize your device and remember certain information about your visit, such as your preferences and actions. Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your device until they expire or are deleted, while session cookies are deleted when you close your browser.
          </p>

          <h3>How We Use Cookies and Tracking Technologies</h3>
          <p>We use cookies and tracking technologies for various purposes, including:</p>
          <ul>
            <li>Ensuring the security and integrity of our website.</li>
            <li>Remembering your preferences and settings.</li>
            <li>Analyzing site traffic and user behavior to improve our services.</li>
            <li>Delivering relevant advertising and marketing communications.</li>
            <li>Providing a personalized experience based on your interests and activities.</li>
          </ul>
          <p>
            You have the option to control and manage cookies in various ways. Most web browsers allow you to configure your cookie settings, including blocking or deleting cookies. However, please note that if you disable cookies, some features of our website may not function properly.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Information</h2>
          <p>If you have any questions about this privacy policy, please contact us at:</p>
          <p><strong>Email Address:</strong> <a href="mailto:terms@pandanotify.com">terms@pandanotify.com</a></p>
        </section>

        <section className="legal-section">
          <h2>Changes to the Privacy Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page. We advise you to review this privacy policy periodically for any changes.
          </p>
          <p className="legal-attribution">
            This privacy policy was generated by GetThru's Privacy Policy Generator.
          </p>
          <p><strong>Last Updated:</strong> December 15, 2025</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;